import { Injectable } from '@angular/core';
import { PAYWALL_RESULT, RevenueCatUI } from '@revenuecat/purchases-capacitor-ui';

import { ToastService } from '#services/toast/toast.service';
import { ISubscriptionService } from './subscription.interface';
import { PurchaseService } from '#services/purchase/purchase.service';
import { logger } from '#lib/logger';
import { TOAST_CONFIGS } from 'src/app/shared/constants/toast-configs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService implements ISubscriptionService {
  constructor(
    private purchaseService: PurchaseService,
    private toastService: ToastService
  ) {}

  async isUserSubscribedToFullAccess(nextFn: (data: boolean) => void): Promise<void> {
    const subscribed = await this.purchaseService.checkIfUserIsSubscribed();

    if (subscribed) {
      nextFn(subscribed);
      return;
    }

    if (!subscribed) {
      const offering = await this.purchaseService.getOfferings();

      const { result } = await RevenueCatUI.presentPaywall({
        offering,
      });

      logger.log(result, 'SubscriptionService.isUserSubscribedToFullAccess -> result');

      const paywallResult = await this.handlePaywallResult(result);

      nextFn(paywallResult);
    }
  }

  private async handlePaywallResult(result: PAYWALL_RESULT): Promise<boolean> {
    switch (result) {
      case PAYWALL_RESULT.NOT_PRESENTED:
      case PAYWALL_RESULT.ERROR:
      case PAYWALL_RESULT.CANCELLED:
        return false;
      case PAYWALL_RESULT.PURCHASED:
      case PAYWALL_RESULT.RESTORED:
        // Call `checkIfUserIsSubscribed` to update the BehaviorSubject.
        // This will also call getCustomerInfo internally.
        const hasSubscribedBefore = await this.purchaseService.checkIfUserIsSubscribed('all');

        logger.log(
          hasSubscribedBefore,
          'SubscriptionWebService.handlePaywallResult -> User has subscribed'
        );

        this.toastService.showToast(TOAST_CONFIGS.subscriptionPurchased());

        return true;
      default:
        return false;
    }
  }

  resetSubscription() {
    logger.log('complete', 'SubscriptionService.resetSubscription');
  }
}
